import http from '../_http'

const temp = {
  //default
  summaryTemp: (m) => { return http.get(`manager/wsfinder/temp`, m); },
  listTemp: (m) => { return http.post(`manager/wsfinder/temp/list`, m); },
  detailTemp: (m) => { return http.get(`manager/wsfinder/temp/${m.id}`); },

  //crud
  insertTemp: (m) => { return http.post(`manager/wsfinder/temp`, m); },
  updateTemp: (m) => { return http.put(`manager/wsfinder/temp`, m); },
  deleteTemp: (m) => { return http.delete(`manager/wsfinder/temp/${m.id}`); },

  //regist
  registTemp: (m) => { return http.get(`manager/wsfinder/temp/${m.id}`); },

  //apply
  applyTemp: (m) => { return http.post(`manager/wsfinder/temp/apply`, m); },

  //delete
  delTemp: (m) => { return http.post(`manager/wsfinder/temp/delete`, m); },
}

export default temp

export { temp }